import { useTranslation } from "react-i18next";
import SelectCar from "../../images/plan/icon1.png";
import Contact from "../../images/plan/icon2.png";
import Drive from "../../images/plan/icon3.png";

function Plantrip() {
  const { t } = useTranslation();

  return (
    <section className="relative py-20 overflow-hidden md:py-28 ">
      {/* Decorative background elements */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 left-20 w-96 h-96 bg-[#f5272b] rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-20 w-96 h-96 bg-[#f5272b] rounded-full blur-3xl"></div>
      </div>

      <div className="container relative z-10 px-4 mx-auto md:px-8">
        <div className="mx-auto max-w-7xl">
          {/* Header Section */}
          <div className="mb-16 space-y-4 text-center md:mb-20">
            <h3 className="text-[#f5272b] font-semibold text-lg md:text-xl tracking-wide uppercase">
              {t("plan_you_trip")}
            </h3>
            <h2 className="max-w-3xl mx-auto text-4xl font-bold leading-tight text-slate-900 md:text-5xl lg:text-6xl">
              {t("quick_and_easy")}
            </h2>
            <div className="w-24 h-1.5 bg-gradient-to-r from-transparent via-[#f5272b] to-transparent mx-auto rounded-full"></div>
          </div>

          {/* Feature Boxes Grid */}
          <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3 lg:gap-10">
            {/* Box 1 - Select Car */}
            <div className="relative group">
              {/* Hover glow effect */}
              <div className="absolute inset-0 bg-gradient-to-br from-[#f5272b]/20 to-transparent rounded-3xl blur-xl opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>

              <div className="relative bg-gradient-to-br from-slate-800/90 to-slate-900/90 backdrop-blur-sm rounded-3xl p-8 md:p-10 shadow-xl border border-slate-700/50 hover:border-[#f5272b]/50 transition-all duration-300 h-full">
                <div className="flex flex-col items-center space-y-6 text-center">
                  {/* Icon Container */}
                  <div className="relative">
                    <div className="absolute inset-0 bg-[#f5272b]/20 rounded-2xl blur-xl"></div>
                    <div className="relative w-24 h-24 md:w-28 md:h-28 bg-gradient-to-br from-[#f5272b] to-red-700 rounded-2xl flex items-center justify-center shadow-2xl group-hover:scale-110 transition-transform duration-300">
                      <img src={SelectCar} alt="select_car" className="object-contain w-14 h-14 md:w-16 md:h-16" />
                    </div>
                  </div>

                  {/* Step Number */}
                  <div className="absolute flex items-center justify-center w-10 h-10 border rounded-full top-6 right-6 bg-slate-700/50 border-slate-600">
                    <span className="text-[#f5272b] font-bold text-lg">1</span>
                  </div>

                  {/* Content */}
                  <div className="space-y-3">
                    <h3 className="text-2xl font-bold text-white md:text-3xl">{t("select_car")}</h3>
                    <p className="text-base leading-relaxed text-slate-300 md:text-lg">{t("we_offer")}</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Box 2 - Contact Operator */}
            <div className="relative group">
              {/* Hover glow effect */}
              <div className="absolute inset-0 bg-gradient-to-br from-[#f5272b]/20 to-transparent rounded-3xl blur-xl opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>

              <div className="relative bg-gradient-to-br from-slate-800/90 to-slate-900/90 backdrop-blur-sm rounded-3xl p-8 md:p-10 shadow-xl border border-slate-700/50 hover:border-[#f5272b]/50 transition-all duration-300 h-full">
                <div className="flex flex-col items-center space-y-6 text-center">
                  {/* Icon Container */}
                  <div className="relative">
                    <div className="absolute inset-0 bg-slate-700/20 rounded-2xl blur-xl"></div>
                    <div className="relative w-24 h-24 md:w-28 md:h-28 bg-gradient-to-br from-[#f5272b] to-red-700 rounded-2xl flex items-center justify-center shadow-2xl group-hover:scale-110 transition-transform duration-300">
                      <img src={Contact} alt="contact_operator" className="object-contain w-14 h-14 md:w-16 md:h-16" />
                    </div>
                  </div>

                  {/* Step Number */}
                  <div className="absolute flex items-center justify-center w-10 h-10 border rounded-full top-6 right-6 bg-slate-700/50 border-slate-600">
                    <span className="text-[#f5272b] font-bold text-lg">2</span>
                  </div>

                  {/* Content */}
                  <div className="space-y-3">
                    <h3 className="text-2xl font-bold text-white md:text-3xl">{t("contact_operator")}</h3>
                    <p className="text-base leading-relaxed text-slate-300 md:text-lg">{t("our_knowlage")}</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Box 3 - Let's Drive */}
            <div className="relative group md:col-span-2 lg:col-span-1">
              {/* Hover glow effect */}
              <div className="absolute inset-0 bg-gradient-to-br from-[#f5272b]/20 to-transparent rounded-3xl blur-xl opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>

              <div className="relative bg-gradient-to-br from-slate-800/90 to-slate-900/90 backdrop-blur-sm rounded-3xl p-8 md:p-10 shadow-xl border border-slate-700/50 hover:border-[#f5272b]/50 transition-all duration-300 h-full">
                <div className="flex flex-col items-center space-y-6 text-center">
                  {/* Icon Container */}
                  <div className="relative">
                    <div className="absolute inset-0 bg-[#f5272b]/20 rounded-2xl blur-xl"></div>
                    <div className="relative w-24 h-24 md:w-28 md:h-28 bg-gradient-to-br from-[#f5272b] to-red-700 rounded-2xl flex items-center justify-center shadow-2xl group-hover:scale-110 transition-transform duration-300">
                      <img src={Drive} alt="drive" className="object-contain w-14 h-14 md:w-16 md:h-16" />
                    </div>
                  </div>

                  {/* Step Number */}
                  <div className="absolute flex items-center justify-center w-10 h-10 border rounded-full top-6 right-6 bg-slate-700/50 border-slate-600">
                    <span className="text-[#f5272b] font-bold text-lg">3</span>
                  </div>

                  {/* Content */}
                  <div className="space-y-3">
                    <h3 className="text-2xl font-bold text-white md:text-3xl">{t("let_drive")}</h3>
                    <p className="text-base leading-relaxed text-slate-300 md:text-lg">{t("whether_you")}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Plantrip;
